import { SplashScreen } from "components/Splash";
import { Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import MainRoute from "router/MainRoute";
import store, { persistor } from "store";
import ReactGA from "react-ga";

const TRACKING_ID = "G-QJEWKGLPNY";
ReactGA.initialize(TRACKING_ID);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<SplashScreen />}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <MainRoute />
          </PersistGate>
        </Provider>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
